import { Outlet } from 'react-router-dom';

export const PublicApp = () => {
  return <Outlet />;
};
